import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ClearSearchIcon = (props: IconProps) => (
  <Icon height="15px" width="16px" viewBox="0 0 15 16" {...props}>
    <path d="M2.21448 2.78552c-2.878394 2.87839-2.878394 7.55058 0 10.42898 2.87839 2.8784 7.55056 2.8784 10.42892 0 2.8784-2.8784 2.8784-7.55059 0-10.42898-2.87836-2.878389-7.55053-2.8783891-10.42892 0Zm8.34312 3.12869L8.47185 8l2.08575 2.0858-1.04285 1.0429-2.0858-2.0858-2.08579 2.0858-1.04289-1.0429L6.38606 8 4.30027 5.91421l1.04289-1.0429L7.42895 6.9571l2.0858-2.08579 1.04285 1.0429Z" />
  </Icon>
);

export default memo(ClearSearchIcon);
